<template>
  <v-autocomplete
    v-model="selectedOptions"
    :items="items"
    placeholder="Select many..."
    filled
    multiple
    small-chips
    clearable
    item-text="text"
    item-value="value"
    @input="$emit('input', selectedOptions)"
    :disabled="items.length === 0"
  ></v-autocomplete>
</template>
<script>
export default {
  name: 'FilteredAutocomplete',
  data: () => ({
    items: [],
    selectedOptions: []
  }),
  methods: {
    setItems (items) {
      this.items = items
    },
    reset () {
      this.items = []
    }
  }
}
</script>
